/*
 * components/CallComponent/ConnectingLoader.ts
 * Anvilo, Inc.
 *
 * This is a modal loading component. Appears when connection is lost or hasn't set up yet.
 *
 * Created by Artem Yefimenko on 12/05/2020
 * Copyright (c) 2020 Anvilo, Inc. All right reserved.
 */

import React, { useEffect } from "react";
import { CircularProgress } from "@material-ui/core";
import { connect, useDispatch } from "react-redux";
import { Fade } from "@material-ui/core";

import WholeCoverMask from "../modal/WholeCoverMask";
import {
  makeStyles,
  Theme,
} from "@material-ui/core";

import ipcConstants from "@constants/ipcConstants";
import uiString from "../../constants/uiString";

import appConfig from "../../config";
import InputButton from "@components/PresentationComponents/FormComponents/InputButton";

import { useAuthContext } from "../../context/AuthProvider";

function ConnectingLoader() {
  const ipcRenderer = appConfig.electron?.ipcRenderer;
  const {logout} = useAuthContext();

  useEffect(() => {
    ipcRenderer?.emit(ipcConstants.OPEN_CONNECTION_LOST_NOTIFICATION);
    return () => {
      ipcRenderer?.emit(ipcConstants.CLOSE_CONNECTION_LOST_NOTIFICATION);
    };
  }, []);

  return (
    <Fade in={true} style={{ transitionDelay: "3000ms",  }}>
      <div style={{ padding: "0",  }}>
          <div
            style={{
              zIndex: 8,
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              alignItems: "center",
              border: "1px solid var(--color-dark-grey)",
              borderRadius: "10px",
              boxShadow: "rgb(0 0 0 / 10%) 0px 4px 24px 0px",
              padding: "0rem 1rem 0rem 2.5rem",
              background: "var(--color-white) ",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              bottom: "2rem",
              gap: "1rem"
            }}
          >
            <CircularProgress style={{ width: "25px", height: "25px" }} />
            <div>
              <div>{uiString.ERROR_CONNECTING_TO_SIP}</div>
            </div>
            <InputButton
              style={{
                height: "25px",
                padding: 0,
                margin: "10px 0",
                borderRadius: "10px",
              }}
              onClick={() => {
                if (appConfig.clientType === "desktop") {
                  appConfig.electron.remote.app.relaunch();
                  appConfig.electron.remote.app.exit(0);
                } else {
                  window.location.reload();
                }
              }}
              className="dev-button"
            >
              {uiString.RELOAD}
            </InputButton>
            <InputButton
              style={{
                height: "25px",
                padding: 0,
                margin: "10px 0",
                borderRadius: "10px",
                color: "black",
              }}
              onClick={() => logout()}
              variant="text"
            >
              <div style={{ textDecoration: "underline" }}>
                {uiString.LOGOUT}
              </div>
            </InputButton>
          </div>
      </div>
    </Fade>
  );
}

export default ConnectingLoader;
